<template>
  <div class="clearfix" style="width: 1190px;margin: 0 auto;position: relative;margin-top: 20px;min-height: 400px;padding-bottom: 20px;">
    <div class="tabs-root">
      <el-tabs v-model="activeName">
        <el-tab-pane name="first">
          <span slot="label" style="font-size: 18px;font-weight: bold;">环球视野</span>
          <article-list-index ref="ali" classType="1" />
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label" style="font-size: 18px;font-weight: bold;">润智学堂</span>
          <article-list-index classType="2" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="width: 300px;float: right;padding-bottom: 20px;">
      <div>
        <el-button :type="hasSigned ? 'info' : 'primary'" style="width:100%;margin-top: 40px;" @click="openCheck">{{
          hasSigned ? '已签到' : '签到'
        }}</el-button>
      </div>
      <div style="margin-top: 10px;">
        <template v-for="tItem in tjzlszConfigs">
          <div :key="tItem.id" class="recommend-list" @click="toDetail(tItem)">
            <img style="width: 300px;height: 180px;" :src="tItem.imgurl" />
            <div style="padding: 5px 10px 5px;color: #333;font-size: 15px;font-weight: bold;">{{ tItem.name }}</div>
            <div
              style="padding: 0 10px 4px;color: #666;font-size: 12px;line-height:16px;height: 60px;overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;"
            >
              {{ tItem.describe }}
            </div>
            <div class="clearfix" style="padding: 0 4px 4px">
              <!-- <label style="font-size: 12px;color: #999;float: left;line-height: 22px;">23关注</label> -->
              <el-button size="mini" round style="float: right;padding: 4px 8px;">查看</el-button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import ArticleListIndex from './ArticleListIndex'
import xy_config from '@/config/xy_config'
export default {
  name: 'ArticleTabs',
  data() {
    return {
      activeName: 'first'
    }
  },
  computed: {
    signInfo() {
      return this.$store.getters.signInfo
    },
    continueSign() {
      return this.$store.getters.continueSign
    },
    hasSigned() {
      return this.$store.getters.hasSigned
    },
    tjzlszConfigs() {
      return this.$store.getters.tjzlszConfigs
    }
  },
  methods: {
    toDetail(item) {
      if (item) {
        if (item.code) {
          this.$router.push({ name: 'ArticleDetail', query: { id: item.code } })
        } else if (item.url) {
          window.location.href = item.url
        }
      }
    },
    openCheck() {
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        this.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
      }
      this.$emit('openCheckModule')
    }
  },
  components: {
    ArticleListIndex
  }
}
</script>
<style lang="less" scoped>
.tabs-root {
  width: 860px;
  min-width: 860px;
  margin: 0;
  position: relative;
  float: left;
}
.recommend-list {
  cursor: pointer;
  width: 100%;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  margin-top: 10px;
}
</style>
